<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-xs-12">
                <div class="container small" style="margin-top: 30px;" data-test-id="SigninView">
                    <div class="border-box">

                        <div v-if="isStepForm">
                            <h3 class="fg-color-blue">Request an account</h3>
                            <br />

                            <div class="form-group">
                                <label for="Email">Email:</label>
                                <input type="email" class="form-control">
                                <div class="error" data-bind="text: EmailError"></div>
                            </div>

                            <div class="form-group">
                                <label for="FirstName">First name:</label>
                                <input type="text" class="form-control">
                                <div class="error" data-bind="text: FirstNameError"></div>
                            </div>

                            <div class="form-group">
                                <label for="LastName">Last name:</label>
                                <input type="text" class="form-control">
                                <div class="error" data-bind="text: LastNameError"></div>
                            </div>
                            <br />

                            <button @click="handleNext" type="button" class="btn btn-primary btn-lg btn-block">Next</button>
                        </div>

                        <div v-if="isStepWorkspaces">
                            <h3 class="fg-color-blue">Select workspaces</h3>
                            <br />

                            <ul class="list-group">
                                <li class="list-group-item">
                                    <strong>Default</strong><br />
                                    <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</small>
                                </li>
                                <li class="list-group-item">
                                    <strong>Prioritization 2021</strong><br />
                                    <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</small>
                                </li>
                                <li class="list-group-item">
                                    <strong>Prioritization 2022</strong><br />
                                    <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</small>
                                </li>
                                <li class="list-group-item">
                                    <strong>Playground</strong><br />
                                    <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</small>
                                </li>
                                <li class="list-group-item">
                                    <strong>Secret</strong><br />
                                    <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</small>
                                </li>
                            </ul>
                            <br />

                            <button @click="handleNext" type="button" class="btn btn-primary btn-lg btn-block">Send request</button>
                        </div>

                        <br />

                        <span>
                            <span>Already have an account?</span>
                            <a href="/#/organizations/users/signin">Sign-in</a>
                        </span>
                    </div>
                </div>
                <br />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";

    @Component
    export default class RequestUserAccountPage extends mixins(PageBase) {
        step: String = 'form';

        get isStepForm() { return this.step == 'form'; }
        get isStepWorkspaces() { return this.step == 'workspaces'; }

        handleNext() {
            this.step = 'workspaces';
        }
    }
</script>

<style scoped>
</style>